// extracted by mini-css-extract-plugin
export default {"scroll-to-top":"Web_scroll-to-top__MxHd5","visible":"Web_visible__e+nIJ","arrow":"Web_arrow__o6gTk"};